module.exports = __webpack_public_path__ + "img/ledger-live-setting-step-four.c088d856.png";